// packages/url/src/get-query-arg.ts
import { getQueryArgs } from "./get-query-args.mjs";
function getQueryArg(url, arg) {
  return getQueryArgs(url)[arg];
}
export {
  getQueryArg
};
//# sourceMappingURL=get-query-arg.mjs.map
